/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import DocumentTemplate from './DocumentTemplate/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconSubtract from 'DesignSystem/Svgs/TysiaIconSubtract/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/NewTask/Content/Actions/Content/Action"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Action.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-2jfVQF': dtColorsNeutral300,'--bblr-2-2jfVQF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-3-2jfVQF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-4-2jfVQF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-5-2jfVQF': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Action.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-6-2jfVQF': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-7-2jfVQF': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-8-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-1-2jfVQF': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Action.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-10-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<div
  data-testid="Action.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-11-2jfVQF': dtColorsNeutral200,'--pl-6-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-7-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text={1}
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Generate letter"
/>
</div>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={onClick}
 marginTop={6}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconSubtract
{...childProps}
  viewPath={`${viewPath}/TysiaIconSubtract`}
 width={24}
 height={24}
 fill={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
<div
  data-testid="Action.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-6-2jfVQF': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-7-2jfVQF': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-8-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-2jfVQF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical2}`}
>
<DocumentTemplate
  viewPath={`${viewPath}/DocumentTemplate`}
/>
</div>
</div>
{children}
</React.Fragment>)
}